export const CategoriesEnum = {
    TouriTipps: process.env.NODE_ENV === "production" ? 288 : 288,
    TippsOfTheWeek: process.env.NODE_ENV === "production" ? 27 : 184,
}
